import { Grid } from "@mui/material";
import React from "react";
import { DialogSectionCard } from "source/components/framework/Dialog/DialogSectionCard";
import { ITaskDataRow } from "ui/Scripts/source/models/task/taskDataRow";
import { ITaskEditTypeItem } from "ui/Scripts/source/models/task/taskEditTypeItem";
import { Translations } from "ui/Scripts/source/models/translations";
import { ChartDesignerBuilderChartContainer } from "./ChartBuilderChartContainer";
import { ITaskTypeChart } from "ui/Scripts/source/models/task/taskTypeChart";
import { TaskTypeDialogChartDesignerDroppableId } from "../../FormDesignerTypes";

interface IChartDesignerBuilderProps {
    draggingSource?: string;
    taskType: ITaskEditTypeItem;
    selectedTaskTypeChart: ITaskTypeChart;
    chartTestDataRows: ITaskDataRow[];
    onChartClick: (name: string) => void;
    onRemoveChart: (name: string) => void;
    onCopyChart: (name: string) => void;
}

export const ChartDesignerBuilder = (props: IChartDesignerBuilderProps) => {
    return (
        <DialogSectionCard
            width="100%"
            headerTitle={Translations.DesignArea}
            contentPadding="16px 0!important"
        >
            <Grid sx={{
                overflowY: "auto",
                overflowX: "hidden",
                height: "calc(100vh - 350px)",
                paddingLeft: "0",
                paddingRight: "0"
            }}>
                <ChartDesignerBuilderChartContainer
                    droppableId={TaskTypeDialogChartDesignerDroppableId.Design}
                    pickerDroppableId={TaskTypeDialogChartDesignerDroppableId.Picker}
                    draggingSource={props.draggingSource}
                    taskType={props.taskType}
                    chartTestDataRows={props.chartTestDataRows}
                    selectedTaskTypeChart={props.selectedTaskTypeChart}
                    onClick={props.onChartClick}
                    onRemove={props.onRemoveChart}
                    onCopy={props.onCopyChart}
                />
            </Grid>
        </DialogSectionCard>
    );
};
